import React, { useState, useEffect } from 'react'
import DropdownActionButton from '../../components/action_button/DropdownActionButton'
import DatePicker from 'react-multi-date-picker'
import Toolbar from 'react-multi-date-picker/plugins/toolbar'
import dayjs from '../../utils/dayjsConfig'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar } from '@fortawesome/free-solid-svg-icons'
import ShowClientMapModalContent from './ShowClientMapModalContent'
import { Button, Modal } from 'react-bootstrap'

export default function ClientsInRoutePlanList({
  client,
  clientIndex,
  handleDeleteClient,
  handleChangeStartDate,
  handleChangeVisitDays,
  handleChangeRecurrence
}) {
  const [recurrenceWeekDaysSelection, setRecurrenceWeekDaysSelection] = useState(
    client.selectedWeekDays || []
  )
  const [recurrenceType, setRecurrenceType] = useState(client.recurrenceType)
  const [recurrenceAmount, setRecurrenceAmount] = useState(client.recurrenceAmount)
  const [showClientLocation, setShowClientLocation] = useState(false)

  const handleCloseClientLocation = () => setShowClientLocation(false)

  const handleOpenClientLocation = () => {
    setShowClientLocation(true)
  }

  const recurrenceWeekDays = [
    { value: 1, text: 'L' },
    { value: 2, text: 'M' },
    { value: 3, text: 'M' },
    { value: 4, text: 'J' },
    { value: 5, text: 'V' },
    { value: 6, text: 'S' },
    { value: 0, text: 'D' }
  ]

  const recurrenceOptions = [
    { value: '', text: 'Escoja una opción', hidden: true },
    { value: 7, text: 'Semana(s)' },
    { value: 28, text: 'Mes(es)' }
  ]

  useEffect(() => {
    setRecurrenceWeekDaysSelection(client.selectedWeekDays || [])
  }, [client.value, client.selectedWeekDays])

  useEffect(() => {
    setRecurrenceType(client.recurrenceType)
    setRecurrenceAmount(client.recurrenceAmount)
  }, [client.value, client.recurrenceType, client.recurrenceAmount])

  useEffect(() => {
    const normalizedRecurrenceType = Number(recurrenceType)
    if (!recurrenceType || Number.isNaN(normalizedRecurrenceType)) return
    const amount = parseInt(recurrenceAmount, 10)
    if (!amount || amount < 1) return
    if (
      normalizedRecurrenceType === Number(client.recurrenceType) &&
      amount === Number(client.recurrenceAmount)
    ) {
      return
    }
    handleChangeRecurrence(client.value, recurrenceType, recurrenceAmount)
  }, [client.value, client.recurrenceAmount, client.recurrenceType, recurrenceType, recurrenceAmount])

  const renderDateInput = () => {
    return (
      <DatePicker
        months={[
          'Ene',
          'Feb',
          'Mar',
          'Abr',
          'May',
          'Jun',
          'Jul',
          'Ago',
          'Sep',
          'Oct',
          'Nov',
          'Dic'
        ]}
        weekDays={['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab']}
        format="DD/MM/YYYY"
        weekStartDayIndex={1}
        highlightToday={false}
        numberOfMonths={1}
        minDate={dayjs().local().startOf('day').toDate()}
        value={Date.parse(client.startDate)}
        onChange={(dateObjects) => {
          handleDateFilter(dateObjects)
        }}
        plugins={[
          <Toolbar
            position="bottom"
            names={{
              today: 'Hoy'
            }}
            sort={['today']}
          />
        ]}
        render={(value, openCalendar) => {
          return (
            <div key={`flr-date`}>
              <div className="react-filter-box route-plan-datepicker-width">
                <div
                  title="Fecha de inicio de ruta"
                  onClick={openCalendar}
                  className="react-filter-box-clickable-zone"
                >
                  <div className="react-filter-titles">
                    {value?.length > 0 && (
                      <>
                        {Array.isArray(value) ? (
                          <div className="filter-title-overflow">{value.join(' - ')}</div>
                        ) : (
                          <div className="filter-title-overflow">{value}</div>
                        )}
                        <FontAwesomeIcon style={{ color: '#597fa9' }} icon={faCalendar} />
                      </>
                    )}
                    {value?.length == 0 && (
                      <>
                        <div className="filter-title-overflow">dd/mm/yyyy</div>
                        <FontAwesomeIcon style={{ color: '#597fa9' }} icon={faCalendar} />
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )
        }}
      />
    )
  }

  const renderRecurrenceDropdown = () => {
    return (
      <div className="recurrence-input-div">
        <input
          min="1"
          max="12"
          step="any"
          type="number"
          autoComplete="off"
          name="recurrence-amount"
          onChange={(e) => setRecurrenceAmount(e.target.value)}
          className="recurrence-amount-input"
          placeholder="1"
          value={recurrenceAmount}
          required
        />
        <select
          className="recurrence-week-dropdown-box custom-select"
          name="recurrence"
          required
          value={recurrenceType}
          onChange={handleRecurrenceTypeChange}
        >
          {recurrenceOptions.map((option) => (
            <option key={option.value} value={option.value} hidden={option.hidden}>
              {option.text}
            </option>
          ))}
        </select>
      </div>
    )
  }

  const handleDateFilter = (dateObj) => {
    if (!dateObj || dateObj.length === 0) {
      return
    }
    const formatedDate = dayjs.unix(dateObj.unix)
    const startDate = dayjs.min(formatedDate).startOf('day')
    handleChangeStartDate(client.value, startDate.toISOString())
  }

  const handleRecurrenceTypeChange = (event) => {
    setRecurrenceType(event.target.value)
  }

  const handleToggleDay = (day) => {
    const dayVal = day?.value
    const weekDaySelected = recurrenceWeekDays.find((day) => day.value === dayVal)
    if (!weekDaySelected) {
      return
    }

    const index = recurrenceWeekDaysSelection.findIndex(
      (day) => day.value === weekDaySelected.value
    )
    if (index === -1) {
      const nextSelection = [...recurrenceWeekDaysSelection, weekDaySelected]
      setRecurrenceWeekDaysSelection(nextSelection)
      handleChangeVisitDays(client.value, nextSelection)
    } else {
      let arr = [...recurrenceWeekDaysSelection]
      arr.splice(index, 1)
      setRecurrenceWeekDaysSelection(arr)
      handleChangeVisitDays(client.value, arr)
    }
  }

  return (
    <>
      <tr>
        <td className="td-text-limited td-text-limited-space">{clientIndex + 1}</td>
        <td className="td-text-limited">{client.label}</td>
        <td className="td-text-limited">{renderDateInput()}</td>
        <td className="td-text-limited">
          <div className="days-btn-group">
            {recurrenceWeekDays.map((day, index) => (
              <button
                type="button"
                onClick={() => handleToggleDay(day)}
                title={day.text}
                key={index}
                className={`route-weekdays-btn ${recurrenceWeekDaysSelection.find((d) => d.value === day.value) && 'active'}`}
              >
                {day.text}
              </button>
            ))}
          </div>
        </td>
        <td className="td-text-limited">{renderRecurrenceDropdown()}</td>
        <td className="td-text-limited" style={{ display: '', justifyContent: 'center' }}>
          <DropdownActionButton
            id={`btn-dropdown-${client.value}`}
            list={[
              {
                text: 'Ver ubicación en mapa',
                handler: (e) => {
                  handleOpenClientLocation()
                }
              },
              {
                text: 'Eliminar cliente',
                handler: (e) => {
                  handleDeleteClient(client.value, e)
                }
              }
            ]}
          />
        </td>
      </tr>

      <Modal
        show={showClientLocation}
        dialogClassName="modal-90w"
        onHide={handleCloseClientLocation}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton className="no-border-bottom">
          <Modal.Title id="example-modal-sizes-title-lg">
            <b className="ft-16">Ubicación del cliente</b>
          </Modal.Title>
        </Modal.Header>

        <Modal.Header className="d-flex flex-column align-items-start">
          <p className="text-title-modal-map">Cliente: {client.label}</p>
        </Modal.Header>
        <Modal.Body>
          <div id="map-canvas">
            <ShowClientMapModalContent
              clientLatitude={client.client.geographical_latitude}
              clientLongitude={client.client.geographical_longitude}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="light"
            onClick={handleCloseClientLocation}
            className="custom-close-button"
          >
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
